import { ElementPosition } from './ElementPosition';
import { Size } from './Size';
import { Rectangle } from './Rectangle';
export class ElementHandle {
    constructor(relativePos, type, elementUUID, engine) {
        this.referencePosition = new ElementPosition('center');
        this.type = 'scale'; // or rotate
        this.elementUUID = elementUUID;
        this.relativePos = relativePos;
        this.type = type;
        this._engine = engine;
    }
    get element() {
        return this._engine.find(this.elementUUID);
    }
    get rotation() {
        return this.element.rotation;
    }
    getCornerPosition(elPos) {
        return elPos.getPosition(this);
    }
    get coords() {
        // for (let i = 0; i < 360; i += 10)
        //     DebugTools.drawPosition(Rotation.rotatePoint(i * 3.14 / 180, this.center, this.element.center), 1, 'purple')
        return {
            tl: this.getCornerPosition(new ElementPosition('tl')),
            tr: this.getCornerPosition(new ElementPosition('tr')),
            bl: this.getCornerPosition(new ElementPosition('bl')),
            br: this.getCornerPosition(new ElementPosition('br'))
        };
    }
    get center() {
        return new ElementPosition('center').getPosition(this);
    }
    get pos() {
        //DebugTools.drawPosition(Rotation.rotatePoint(this.element.angle, this.relativePos.getPosition(this.element), this.element.center), 3, 'yellow')
        return this.relativePos.getPosition(this.element);
    }
    get x() {
        return this.pos.x;
    }
    get y() {
        return this.pos.y;
    }
    get name() {
        return this.relativePos.namePosition;
    }
    isInside(pos) {
        return this.hitbox.isInside(pos);
    }
    get size() {
        return new Size(
            ElementHandle.size / this._engine.canvas.width,
            ElementHandle.size / this._engine.canvas.height
        );
    }
    get hitbox() {
        return new Rectangle(this.coords.tl, this.coords.bl, this.coords.br, this.coords.tr);
    }
}
ElementHandle.size = 30;
